// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});
})();

// Swiper strona główna 1
var swiper = new Swiper('.mySwiper', {
	loop: true,
	autoplay: {
        delay: 5000,
        disableOnInteraction: true,
    },
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
});

// Swiper strona główna 2
var swiper2 = new Swiper('.referencjeSwiper', {
	loop: true,
	autoplay: {
        delay: 5000,
        disableOnInteraction: true,
    },
    navigation: {
        nextEl: '.referencje-slider-next',
        prevEl: '.referencje-slider-prev',
    },
    pagination: {
        el: '.referencje-slider-pagination',
        clickable: true,
    },
});

// Funkcjonalność przycisku zamykania rozwijanego menu
document.getElementById('zamknij-menu').addEventListener('click', function() {
    document.querySelector('.navbar-toggler').click();
});

// Body się nie scrolluje, kiedy nawigacja jest rozwinięta
document.querySelector('.navbar-toggler').addEventListener('click', function() {
    var navbarCollapse = document.querySelector('#navbarNavDropdown');

    navbarCollapse.addEventListener('shown.bs.collapse', function () {
        document.body.classList.add('no-scroll');
    });

    navbarCollapse.addEventListener('hidden.bs.collapse', function () {
        document.body.classList.remove('no-scroll');
    });
});